import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';

// Páginas
import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';
import ProductDetailPage from './pages/ProductDetailPage';
import LeadsPage from './pages/LeadsPage';
import LeadProfilePage from './pages/LeadProfilePage';
import LeadManagementPage from './pages/LeadManagementPage';
import SettingsPage from './pages/SettingsPage';
import SocialMediaPage from './pages/SocialMediaPage';
import SuportePage from './pages/SuportePage';
import ChatIAPage from './pages/ChatIAPage';
import WhatsAppAIPage from './pages/WhatsAppAIPage';
import EmailResponsePage from './pages/EmailResponsePage';
import EmailMonitoringPage from './pages/EmailMonitoringPage';
import ConversationHistoryPage from './pages/ConversationHistoryPage';
import StatusPage from './pages/StatusPage';
import ProfilePage from './pages/ProfilePage';
import ConfigPage from './pages/ConfigPage';
import MarketingPage from './pages/MarketingPage';
import MarketingPagePrototype from './pages/MarketingPagePrototype';
import ProductPagePrototype from './pages/ProductPagePrototype';
import IndicarAmigoPage from './pages/IndicarAmigoPage';
import MkIAPage from './pages/MkIAPage';
import CampaignsPage from './pages/CampaignsPage';
import NotificationsPage from './pages/NotificationsPage';
import PlanosPage from './pages/PlanosPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import EventsPage from './pages/EventsPage';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Rotas públicas */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/marketing-prototype" element={<MarketingPagePrototype />} />
      <Route path="/produtos-prototype" element={<ProductPagePrototype />} />
      
      {/* Rota de planos - acessível mesmo com plano expirado, mas requer autenticação */}
      <Route 
        path="/planos" 
        element={
          <ProtectedRoute requiresSubscription={false}>
            <Layout>
              <PlanosPage />
            </Layout>
          </ProtectedRoute>
        } 
      />

      {/* Rotas protegidas que exigem autenticação e plano válido */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout>
              <Outlet />
            </Layout>
          </ProtectedRoute>
        }
      >
        {/* Configurando DashboardPage como página principal */}
        <Route index element={<DashboardPage />} />
        <Route path="home" element={<HomePage />} />
        <Route path="eventos" element={<EventsPage />} />
        <Route path="produtos" element={<ProductPagePrototype />} />
        <Route path="produtos/:id" element={<ProductDetailPage />} />
        <Route path="leads" element={<LeadsPage />} />
        <Route path="leads/:id" element={<LeadProfilePage />} />
        <Route path="gerenciar-leads" element={<LeadManagementPage />} />
        <Route path="redes-sociais" element={<SocialMediaPage />} />
        <Route path="marketing" element={<MarketingPage />}>
          <Route index element={<Navigate to="campanhas" replace />} />
          <Route path="campanhas" element={<CampaignsPage />} />
          <Route path="historico" element={<ConversationHistoryPage />} />
          <Route path="mk-ia" element={<MkIAPage />} />
        </Route>
        <Route path="configuracoes" element={<ConfigPage />} />
        <Route path="suporte" element={<SuportePage />} />
        <Route path="chat-ia" element={<ChatIAPage />} />
        <Route path="whatsapp-ai" element={<WhatsAppAIPage />} />
        <Route path="email-response" element={<EmailResponsePage />} />
        <Route path="email-monitoring" element={<EmailMonitoringPage />} />
        <Route path="conversas" element={<ConversationHistoryPage />} />
        <Route path="status" element={<StatusPage />} />
        <Route path="perfil" element={<ProfilePage />} />
        <Route path="notificacoes" element={<NotificationsPage />} />
        <Route path="indicar-amigo" element={<IndicarAmigoPage />} />
      </Route>

      {/* Rota de fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;